import React from 'react'
import BasicSlider from './BasicSlider'

function Appp() {
  return (
   <>
    <BasicSlider/>
    
    </>

  )
}

export default Appp

